howspace.components.sortableList = (() => {
    'use strict';

    // Allow dragging only one item at a time.
    let dragging = false;

    // Store certain variables when the dragging starts.
    let dragItem = null;
    let dragItemCurrentIndex = null;
    let dragItemOriginalIndex = null;
    let verticalShift = null;
    let minY = null;
    let maxY = null;
    let sortables = [];
    let startDragY = 0;
    let previousDragY = null;
    let dragItemDy = 0;

    const captureClicksWhenDragging = e => {
        if (dragging) {
            e.preventDefault();
            e.stopPropagation();
            return false;
        }
    };

    const startItemDrag = e => {
        if (dragging) {
            // An item is already being dragged.
            stopItemDrag();
        }

        if (e.originalEvent.pointerType === 'mouse' && e.originalEvent.button !== 0) {
            // Do not start dragging if the pointer is mouse and user didn't click with left button.
            return;
        }

        dragging = true;
        dragItem = $(e.target).closest('.howspace-sortable-list-item');

        // Clear any selected text.
        window.getSelection().removeAllRanges();

        // Set pointer capture to the drag item (the target captures all pointer events).
        dragItem[0].setPointerCapture(e.pointerId);

        // Drag when moving the pointer.
        dragItem[0].addEventListener('pointermove', drag, {passive: true});

        const sortableListItems = dragItem.closest('.howspace-sortable-list-items');
        const sortableList = sortableListItems.closest('.howspace-sortable-list');

        // Limit dragging within the parent.
        const dragItemParentBox = sortableListItems[0].getBoundingClientRect();
        minY = dragItemParentBox.y;
        maxY = minY + dragItemParentBox.height;

        // Store positions on drag start.
        let spaceBetweenItems = 0;
        let firstItemBottom = null;
        let secondItemTop = null;
        let aboveDragItem = true;
        sortableListItems.children('.howspace-sortable-list-item').each(function (index, item) {
            const box = item.getBoundingClientRect();

            // Calculate the space between the sortable items.
            if (index === 0) {
                firstItemBottom = box.y + box.height;
            } else if (index === 1) {
                secondItemTop = box.y;
                spaceBetweenItems = secondItemTop - firstItemBottom;
            }

            if (item === dragItem[0]) {
                dragItemOriginalIndex = index;
                dragItemCurrentIndex = index;
                aboveDragItem = false;
                return true;
            }

            sortables.push({
                item: item,
                originalIndex: index,
                originalTop: box.y,
                originalBottom: box.y + box.height,
                currentIndex: index,
                currentTop: box.y,
                currentBottom: box.y + box.height,
                aboveDragItem: aboveDragItem,
            });
        });
        verticalShift = dragItem[0].getBoundingClientRect().height + spaceBetweenItems;

        // Add dragging class to the component.
        sortableList.addClass('dragging');

        // Store start pageY to calculate the drag distance.
        startDragY = e.pageY;
        previousDragY = e.pageY;

        // Add dragging class name to the item.
        dragItem.addClass('dragging');
    };

    const drag = e => {
        if (!dragging) {
            return;
        }

        // Drag the item.
        dragItemDy = e.pageY - startDragY;
        dragItem.css('transform', `translateY(${dragItemDy}px)`);

        // Do not let the dragged item leave the parent.
        const dragItemBox = dragItem[0].getBoundingClientRect();
        if (dragItemBox.y < minY) {
            dragItemDy += minY - dragItemBox.y;
        }
        if (dragItemBox.y + dragItemBox.height > maxY) {
            dragItemDy -= dragItemBox.y + dragItemBox.height - maxY;
        }
        dragItem.css('transform', `translateY(${dragItemDy}px)`);

        // Move other items (if needed).
        const pointerDy = e.pageY - previousDragY;
        const movingDown = pointerDy > 0;
        const movingUp = pointerDy < 0;
        previousDragY = e.pageY;

        if (!movingDown && !movingUp) {
            // No vertical movement.
            return;
        }

        let y = dragItemBox.y;
        if (movingDown) {
            // When moving downwards, check y from the bottom of the item being dragged.
            y += dragItemBox.height;
        }

        real.loop(sortables, sortable => {
            if (movingDown && y > sortable.currentTop) {
                if (sortable.aboveDragItem) {
                    // Item was shifted below the drag item, reset it back up to its original position.
                    sortable.currentIndex = sortable.originalIndex;
                    sortable.currentTop = sortable.originalTop;
                    sortable.currentBottom = sortable.originalBottom;
                } else {
                    // Shift item above the dragged item.
                    sortable.currentIndex = sortable.originalIndex - 1;
                    sortable.currentTop = sortable.originalTop - verticalShift;
                    sortable.currentBottom = sortable.originalBottom - verticalShift;
                }
            } else if (movingUp && y < sortable.currentBottom) {
                if (sortable.aboveDragItem) {
                    // Shift item below the dragged item.
                    sortable.currentIndex = sortable.originalIndex + 1;
                    sortable.currentTop = sortable.originalTop + verticalShift;
                    sortable.currentBottom = sortable.originalBottom + verticalShift;
                } else {
                    // Item was shifted above the drag item, reset it back down to its original position.
                    sortable.currentIndex = sortable.originalIndex;
                    sortable.currentTop = sortable.originalTop;
                    sortable.currentBottom = sortable.originalBottom;
                }
            }
        });

        dragItemCurrentIndex = 0;
        real.loop(sortables, sortable => {
            if (
                (sortable.currentIndex === sortable.originalIndex && sortable.aboveDragItem) ||
                (sortable.currentIndex < sortable.originalIndex && !sortable.aboveDragItem)
            ) {
                dragItemCurrentIndex++;
            }

            if (sortable.currentIndex > sortable.originalIndex && sortable.aboveDragItem) {
                sortable.item.style.transform = `translateY(${verticalShift}px)`;
            } else if (sortable.currentIndex < sortable.originalIndex && !sortable.aboveDragItem) {
                sortable.item.style.transform = `translateY(-${verticalShift}px)`;
            } else {
                sortable.item.style.transform = '';
            }
        });
    };

    const stopItemDrag = () => {
        if (!dragging) {
            return;
        }

        const sortableListItems = dragItem.closest('.howspace-sortable-list-items');
        const sortableList = sortableListItems.closest('.howspace-sortable-list');

        if (dragItemOriginalIndex !== dragItemCurrentIndex) {
            // Dragged item was moved, change its position in DOM.
            destroyTextEditors(dragItem);
            if (dragItemCurrentIndex < dragItemOriginalIndex) {
                sortableListItems.children('.howspace-sortable-list-item').eq(dragItemCurrentIndex).before(dragItem);
            } else {
                sortableListItems.children('.howspace-sortable-list-item').eq(dragItemCurrentIndex).after(dragItem);
            }
            initTextEditors(dragItem);

            // Reset all transforms.
            sortableListItems.children('.howspace-sortable-list-item').addClass('no-movement-transition').css('transform', '');
            requestAnimationFrame(() => {
                sortableListItems.children('.howspace-sortable-list-item').removeClass('no-movement-transition');
            });

            // Fire item moved event.
            howspace.dispatchEvent(sortableList, howspace.components.sortableList.ITEM_MOVED, {item: dragItem});
        }

        // Remove dragging class from the component and dragged item.
        sortableList.removeClass('dragging');
        dragItem.css('transform', '').removeClass('dragging');

        // Stop listening to pointermove (drag) event.
        dragItem[0].removeEventListener('pointermove', drag);

        // Reset variables.
        dragItem = null;
        dragItemCurrentIndex = null;
        dragItemOriginalIndex = null;
        verticalShift = null;
        minY = null;
        maxY = null;
        sortables = [];
        startDragY = null;
        previousDragY = null;
        dragging = false;
    };

    window.addEventListener('pointerup', stopItemDrag);

    // TinyMCE editors inside a moved item break when their container is temporarily detached from the DOM.
    // Destroy them synchronously before the move (syncing content to the textarea first) and re-init afterward,
    // so the editor survives intact.
    // We do the teardown inline rather than delegating to howspace.components.textEditor.destroy()
    // because that function awaits an internal promise, deferring class removal to a microtask —
    // by the time initTextEditors() runs, the initialized class would still be present and init()
    // would skip the element.
    const destroyTextEditors = (item) => {
        if (!window.tinymce) {
            return;
        }
        item.find('.howspace-text-editor.howspace-text-editor-initialized').each(function () {
            const editorTextarea = $(this);
            const wrapper = editorTextarea.closest('.howspace-text-editor-wrapper');
            const editor = tinymce.get(this.id);
            if (editor) {
                editor.save();
                tinymce.remove('#' + this.id);
            }
            editorTextarea.removeClass('howspace-text-editor-initialized');
            editorTextarea.removeAttr('id');
            wrapper.removeClass('initializing focused');
        });
    };

    const initTextEditors = (item) => {
        if (howspace.components.textEditor) {
            howspace.components.textEditor.init(item);
        }
    };

    const deleteItem = (e, {restoreFocus = true} = {}) => {
        const item = $(e.target).closest('.howspace-sortable-list-item');
        item.addClass('deleted').dataAndAttr('skip-from-real-form', true);
        if (restoreFocus) {
            item.find('.undelete-btn').first().trigger('focus');
        }
    };

    const undeleteItem = (e, {restoreFocus = true} = {}) => {
        const item = $(e.target).closest('.howspace-sortable-list-item');
        item.removeClass('deleted').dataAndAttr('skip-from-real-form', false);
        if (restoreFocus) {
            item.find('.delete-btn').first().trigger('focus');
        }
    };

    const moveItemWithKeyboard = e => {
        if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') {
            return;
        }

        e.preventDefault();
        const btn = $(e.target);
        const item = btn.closest('.howspace-sortable-list-item');

        if (e.key === 'ArrowDown') {
            const nextItem = item.next('.howspace-sortable-list-item');
            if (nextItem.length > 0) {
                destroyTextEditors(item);
                item.before(nextItem);
                initTextEditors(item);

                // Fire item moved event.
                howspace.dispatchEvent(item.closest('.howspace-sortable-list'), howspace.components.sortableList.ITEM_MOVED, {item: item});
            }
            return;
        }

        if (e.key === 'ArrowUp') {
            const previousItem = item.prev('.howspace-sortable-list-item');
            if (previousItem.length > 0) {
                destroyTextEditors(item);
                item.after(previousItem);
                initTextEditors(item);

                // Fire item moved event.
                howspace.dispatchEvent(item.closest('.howspace-sortable-list'), howspace.components.sortableList.ITEM_MOVED, {item: item});
            }
        }
    };

    const addItem = (sortableList, template, obj = {}) => {
        const item = $(howspace.template.getHtml(template, obj));
        item.addClass('howspace-sortable-list-item added');
        sortableList.children('.howspace-sortable-list-items').append(item);
        sortableList.removeClass('d-none');

        if (howspace.focusFirstInput) {
            howspace.form.focusFirstInput(item);
        }

        // Init components.
        howspace.components.init(item);

        howspace.dispatchEvent(sortableList, howspace.components.sortableList.ITEM_ADDED, {item: item});

        const animHeight = item.outerHeight();

        item.css({height: 0, overflow: 'hidden'});
        howspace.animate(item, {height: animHeight}, 350, () => {
            item.removeAttr('style');
            setTimeout(() => {
                item.removeClass('added');
            }, 700);
        });

        return item;
    };

    return {
        ITEM_ADDED : 'item-added',
        ITEM_MOVED : 'item-moved',
        init: (elem) => {
            elem.findIncludingSelf('.howspace-sortable-list:not(.howspace-sortable-list-initialized)').each(function () {
                const sortableList = $(this);
                sortableList.addClass('howspace-sortable-list-initialized');

                sortableList.find('>.howspace-sortable-list-items > *').addClass('howspace-sortable-list-item');

                sortableList[0].addEventListener('click', captureClicksWhenDragging, {capture: true});

                sortableList.on('pointerdown', '.drag-btn:not(:disabled)', startItemDrag);
                sortableList.on('click', '.delete-btn:not(:disabled)', deleteItem);
                sortableList.on('click', '.undelete-btn:not(:disabled)', undeleteItem);

                sortableList.on('keydown', '.drag-btn:not(:disabled)', moveItemWithKeyboard);
            });
        },
        destroy: (elem) => {
            elem.findIncludingSelf('.howspace-sortable-list.howspace-sortable-list-initialized').each(function () {
                const sortableList = $(this);
                sortableList.removeClass('howspace-sortable-list-initialized');

                sortableList[0].removeEventListener('click', captureClicksWhenDragging, {capture: true});

                sortableList.off('pointerdown', '.drag-btn:not(:disabled)', startItemDrag);
                sortableList.off('click', '.delete-btn:not(:disabled)', deleteItem);
                sortableList.off('click', '.undelete-btn:not(:disabled)', undeleteItem);

                sortableList.off('keydown', '.drag-btn:not(:disabled)', moveItemWithKeyboard);
            });
        },
        addItem: (sortableList, obj = {}) => {
            return addItem(sortableList, sortableList.find('> template'), obj);
        },
        addItemByClass: (sortableList, templateClass, obj = {}) => {
            return addItem(sortableList, sortableList.find('> template.' + templateClass), obj);
        },
        clear: (sortableList) => {
            sortableList.find('.howspace-sortable-list-item').remove();
            sortableList.addClass('d-none');
        },
        count: (sortableList) => {
            return sortableList.find('.howspace-sortable-list-item').length;
        }
    };

})();
